import type { LevelScript } from '@nebulark/engine';

export const STAGE1: LevelScript = {
  id: 'stage1',
  durationSec: 55,
  scrollSpeed: 120,
  bossId: 'boss-stage1',
  spawns: [
    // === 0-10s: tutorial wave — grunts only ===
    { t: 1,  enemyId: 'grunt-straight', x: 90  },
    { t: 1,  enemyId: 'grunt-straight', x: 180 },
    { t: 1,  enemyId: 'grunt-straight', x: 270 },
    { t: 3,  enemyId: 'grunt-straight', x: 60  },
    { t: 3,  enemyId: 'grunt-straight', x: 300 },
    { t: 5,  enemyId: 'grunt-straight', x: 120 },
    { t: 5,  enemyId: 'grunt-straight', x: 240 },
    { t: 7,  enemyId: 'weaver-sine',    x: 180 },
    { t: 9,  enemyId: 'grunt-straight', x: 90  },
    { t: 9,  enemyId: 'grunt-straight', x: 270 },

    // === 10-20s: weavers + grunts ===
    { t: 11, enemyId: 'weaver-sine',    x: 60  },
    { t: 11, enemyId: 'weaver-sine',    x: 300 },
    { t: 13, enemyId: 'grunt-straight', x: 150 },
    { t: 13, enemyId: 'grunt-straight', x: 210 },
    { t: 15, enemyId: 'weaver-sine',    x: 120 },
    { t: 15, enemyId: 'weaver-sine',    x: 240 },
    { t: 17, enemyId: 'grunt-straight', x: 90  },
    { t: 17, enemyId: 'grunt-straight', x: 180 },
    { t: 17, enemyId: 'grunt-straight', x: 270 },
    { t: 19, enemyId: 'weaver-sine',    x: 180 },

    // === 20-30s: first snipers ===
    { t: 22, enemyId: 'orbit-fighter', x: 180, group: 'orbit-a', count: 6, spacing: 0 },
    { t: 21, enemyId: 'sniper-aimed',   x: 120 },
    { t: 21, enemyId: 'grunt-straight', x: 60  },
    { t: 21, enemyId: 'grunt-straight', x: 300 },
    { t: 24, enemyId: 'sniper-aimed',   x: 240 },
    { t: 24, enemyId: 'weaver-sine',    x: 150 },
    { t: 26, enemyId: 'grunt-straight', x: 90  },
    { t: 26, enemyId: 'grunt-straight', x: 270 },
    { t: 28, enemyId: 'sniper-aimed',   x: 180 },
    { t: 29, enemyId: 'weaver-sine',    x: 100 },
    { t: 29, enemyId: 'weaver-sine',    x: 260 },

    // === 30-40s: first swarm + snake ===
    { t: 31, enemyId: 'swarmer', x: 90,  group: 'swarm-a', count: 5, spacing: 22 },
    { t: 33, enemyId: 'grunt-straight', x: 180 },
    { t: 34, enemyId: 'snake-fighter',  x: 180, group: 'snake-a', count: 7, spacing: 0 },
    { t: 35, enemyId: 'swarmer', x: 200, group: 'swarm-b', count: 5, spacing: 22 },
    { t: 37, enemyId: 'sniper-aimed',   x: 80  },
    { t: 37, enemyId: 'sniper-aimed',   x: 280 },
    { t: 39, enemyId: 'weaver-sine',    x: 180 },

    // === 40-50s: mixed chaos ===
    { t: 44, enemyId: 'orbit-fighter', x: 90, group: 'orbit-b', count: 6, spacing: 0 },
    { t: 41, enemyId: 'grunt-straight', x: 60  },
    { t: 41, enemyId: 'grunt-straight', x: 120 },
    { t: 41, enemyId: 'grunt-straight', x: 240 },
    { t: 41, enemyId: 'grunt-straight', x: 300 },
    { t: 43, enemyId: 'sniper-aimed',   x: 180 },
    { t: 44, enemyId: 'weaver-sine',    x: 90  },
    { t: 44, enemyId: 'weaver-sine',    x: 270 },
    { t: 46, enemyId: 'swarmer', x: 60,  group: 'swarm-c', count: 5, spacing: 22 },
    { t: 48, enemyId: 'sniper-aimed',   x: 120 },
    { t: 48, enemyId: 'sniper-aimed',   x: 240 },
    { t: 49, enemyId: 'grunt-straight', x: 180 },

    // === 50-55s: escalation into boss ===
    { t: 50, enemyId: 'snake-fighter',  x: 90,  group: 'snake-b', count: 8, spacing: 0 },
    { t: 51, enemyId: 'swarmer', x: 150, group: 'swarm-d', count: 5, spacing: 22 },
    { t: 53, enemyId: 'weaver-sine',    x: 60  },
    { t: 53, enemyId: 'weaver-sine',    x: 180 },
    { t: 53, enemyId: 'weaver-sine',    x: 300 },
    { t: 55, enemyId: 'sniper-aimed',   x: 90  },
    { t: 55, enemyId: 'sniper-aimed',   x: 270 },
    // Boss spawns at t=55 (durationSec)
  ],
};
